export const EMPTY_LINE = { sku: "", product_name: "", hsn: "", uom: "PCS", quantity: "", rate: "", discount_pct: "", gst_percent: 18, pieces_per_carton: "", packing_type: "", customer_sku: "", customer_po_line: "", stock: null, _q: "", _open: false };
export const newLine = () => ({ ...EMPTY_LINE, _uid: crypto.randomUUID() });
export const newCharge = () => ({ description: "", amount: "", gst_percent: "", _uid: crypto.randomUUID() });

export const lineDisplayValue = (l) => {
  if (l._open) return l._q;
  if (l.sku) return `${l.sku} — ${l.product_name}`;
  return l._q;
};

export const money = (v) => (v == null || isNaN(v) ? "0.00" : Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));

export const remainingShippable = (order) => {
  const lines = order?.items || order?.lines || [];
  const byLine = {};
  const legacyBySku = {};
  (order?.shipments || []).filter((s) => s.status !== "cancelled").forEach((s) => {
    (s.lines || []).forEach((l) => {
      if (l.line_no != null) byLine[l.line_no] = (byLine[l.line_no] || 0) + (l.quantity || 0);
      else legacyBySku[l.sku] = (legacyBySku[l.sku] || 0) + (l.quantity || 0);
    });
  });
  return lines.some((l) => {
    const qty = l.quantity || l.ordered || 0;
    let allocated = l.line_no != null ? (byLine[l.line_no] || 0) : 0;
    const legacy = Math.min(qty - allocated, legacyBySku[l.sku] || 0);
    allocated += Math.max(0, legacy);
    legacyBySku[l.sku] = (legacyBySku[l.sku] || 0) - Math.max(0, legacy);
    return qty > allocated;
  });
};

export const canCreateShipment = (order, fulfilmentStatus) =>
  remainingShippable(order) &&
  order?.documents?.complete === true &&
  !!order?.vehicle_checkin?.completed_at &&
  order?.delivery_mode !== "customer_pickup" &&
  !["closed", "cancelled"].includes(fulfilmentStatus);
